import api from "./api";

/**
 * ✅ GET Route History List
 * Supports search, sort, filter
 */
export async function RouteHistoryListApi(params = {}) {
  try {
    const response = await api.get("/route/history-list/", {
      params,
    });
    return response;
  } catch (error) {
    console.log("Error fetching route history:", error);
    throw error;
  }
}


/**
 * ✅ GET Route History Detail
 */
export async function RouteHistoryDetailApi(id) {
  try {
    const response = await api.get(`/route/history/${id}/`);
    return response;
  } catch (error) {
    console.log("Error fetching route history detail:", error);
    throw error;
  }
}